import {
  ChakraProvider,
} from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import theme from './theme';
import { store } from './store/store';

import '@submize/form/dist/submize-form.css';

const App = () => (
  <ChakraProvider theme={theme} cssVarsRoot="body">
    <ReduxProvider store={store}>
      <Outlet />
    </ReduxProvider>
  </ChakraProvider>

);

export default App;
